import { Component, OnInit } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { LowerCasePipe, DecimalPipe, DatePipe } from '@angular/common';
import { ReportesService } from '../../../services/reportes.service';
import { ExcelTitle } from '../../../interfaces/excel.interface';
import { ExcelService } from '../../../services/excel.service';
import { AlertasModales } from '../../../helpers/alertasModales';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const ID_PAGINA = 34;

@Component({
  selector: 'app-semanal-2',
  templateUrl: './semanal-2.component.html',
  styleUrls: ['./semanal-2.component.css']
})
export class Semanal2Component implements OnInit {
  loaded = false;
  loading = false;
  exportando = false;
  registros = [];
  ruta = 0;
  lowerCasePipe = new LowerCasePipe();
  arrayOfKeys = [];
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  promedios: any;
  private semana = '';
  constructor(
    private excelService: ExcelService,
    private reportesService: ReportesService,
    private route: ActivatedRoute,
    private router: Router,
    empleadoService: EmpleadosServicio,
    private modals: AlertasModales
    ) {
      if (empleadoService.datosEmpleado.tipo_empleado !== 3
        && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA === ID_PAGINA).length) {
        this.router.navigate(['/404']);
      }
  }

  ngOnInit() {
    this.verificarQueryString();
  }

  private initReporte(): void {
    this.loading = true;
    let fecha_desde = '';
    let fecha_hasta = '';
    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    this.reportesService.reporteGeneral(fecha_desde, fecha_hasta, this.ruta)
    .subscribe((res: any) => {
      this.registros = res.firstTable;
      this.promedios = res.secondTable;
      this.semana = res.semana;
      if (this.registros.length) {
        this.arrayOfKeys = Object.keys(this.registros[0]);
      }
      this.loaded = true;
      this.loading = false;
    }, err => {
      this.loaded = true;
      this.loading = false;
      if (err.status === 400) {
        this.modals.validacionesModalJquery('Advertencia', err.error, 'orange', 'modern');
      }
    });
  } 

  filtrar() {
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);  
    if (!isNaN(this.ruta)) {
      queryParams['ruta'] = this.ruta;
    }
    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    this.router.navigate(['./reporte/informe-general'], { queryParams: queryParams });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (!isNaN(params.ruta)) {
          this.ruta = params.ruta;
        }
        if (params.fecha_inicia && params.fecha_termina) {
          const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
          const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
          const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

          if ( !isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit ) ) {
            this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
          }

          const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
          const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
          const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

          if ( !isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd ) ) {
            this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
          }
        }
        this.initReporte();
      }
    });
  }

  getKey(key: string) {
    return key.replace(new RegExp('_', 'g'), ' ')
              .replace('porciento', '%')
              .replace('prestado cobrado', 'p/c')
              .toUpperCase();
  }

  getValue(key: string, value: any) {
    if (!value || isNaN(value)) {
      if (key == 'hr_primer_cobro' || key == 'hr_ultimo_cobro' || key == 'hr_final_cobro') {
        return new DatePipe('en-US').transform(`1999-01-01 ${value}`, 'hh:mm a');
      }

      return value;
    
    } else {

      let prefix = '';
      let suffix = '';
      if (key == 'cuota' || key == 'cobro' || key == 'prestamos' || key == 'gastos' || key == 'gastos_cierre') {
        prefix = '$';
      }
      if (key == 'porciento_cobro' || key == 'porciento_atraso' || key == 'porciento_clientes_cobrados' || key == 'porciento_prestado_cobrado' || key == 'clientes_cobrados_12_porciento') {
        suffix = '%';
      }
      if (key == 'velocidad_cobro' || key == 'velocidad_cobro_12') {
        suffix = ' ctes/h';
      }
      if (key == 'tiempo_total_cobro' || key == 'dif_cierre_ultimo_cobro') {
        suffix = 'hrs';
      }
      return prefix + new DecimalPipe('en-US').transform(value, '1.0-2') + suffix;
    }
  }

  putClassRed(key: string) {
    return key == 'indice_atraso' || key == 'porciento_prestado_cobrado' || key == 'clientes_no_cobrados' || key == 'porciento_clientes_cobrados' || key == 'porciento_atraso' || key == 'porciento_cobro' || key == 'clientes_cobrados_12_porciento' || key == 'velocidad_cobro_12' || key == 'velocidad_cobro' || key == 'tiempo_total_cobro';
  }

  exportar() {
    if (!this.exportando && this.registros.length > 0) {
      const nPipe = new DecimalPipe('en-US');
      const title = `INFORME GENERAL RUTA ${nPipe.transform(this.ruta, '2.0-0')}`;

      this.exportando = true;
      const titulo: ExcelTitle = {
        title,
        font: { name: 'Arial', size: 16, underline: 'double', bold: true }
      };
      const columns: any =  {
      // tslint:disable-next-line:max-line-length
      columns: [],
      columnOptions: [
        {key: 1, properties: {width: 25} },
      ]
      };
      const params: any = {
        rows: [],
      };

      params.rows.push(
        [
          'INFORME GENERAL',
          `RUTA ${nPipe.transform(this.ruta, '2.0-0')}`,
          `Semana ${this.semana}`          
        ]
      )

      let y = 0;
      for (const key of this.arrayOfKeys) {
        const columnsTable: any = [this.getKey(key)];
        y++;
        if(y > 1){
          columns.columnOptions.push( {key: y, properties: {width: 17} })
        }
        for (const data of this.registros) {
          columnsTable.push(this.getValue(key, data[key]));
        }

        let fill: any;
        if (y == 1) {
          fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'DDEBF7' },
            fgFirst: { argb: 'FFFF00' },
          };
        } else {
          fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: this.putClassRed(key) ? 'F8CBAD' : 'FFFFCC' },
            fgFirst: { argb: 'DDEBF7' },
            fgLast: { argb: 'FFFF00' },
          };
        }
        columnsTable.push({
          properties: {
          fill,
          font: {
            color: {argb: '000000'},
            size: 10,
            bold: true
          },
          border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
          }
        })
        params.rows.push(columnsTable);
      }
      params.rows.push(
        ['PROM. CTES. COBR. X DIA', nPipe.transform(this.promedios.promedio_clientes, '1.0-0'),{
          properties: {
            fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F8CBAD' },
            fgFirst: { argb: 'DDEBF7' },
          },
          font: {
            color: {argb: '000000'},
            size: 10,
            bold: true
          },
          border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
          }
        }],
        ['PROM. PREST. X CTES', '$'+nPipe.transform(this.promedios.promedio_prestamo, '1.0-0'),{
          properties: {
            fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F8CBAD' },
            fgFirst: { argb: 'DDEBF7' },
          },
          font: {
            color: {argb: '000000'},
            size: 10,
            bold: true
          },
          border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
          }
        }],
        ['COBRO PROMEDIO', '$'+nPipe.transform(this.promedios.cobro_promedio, '1.0-0'),{
          properties: {
            fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F8CBAD' },
            fgFirst: { argb: 'DDEBF7' },
          },
          font: {
            color: {argb: '000000'},
            size: 10,
            bold: true
          },
          border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
          }
        }],
        ['CUOTA PROMEDIO', '$'+nPipe.transform(this.promedios.cuota_promedio, '1.0-0'),{
          properties: {
            fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F8CBAD' },
            fgFirst: { argb: 'DDEBF7' },
          },
          font: {
            color: {argb: '000000'},
            size: 10,
            bold: true
          },
          border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          }
          }
        }],
      );
      this.excelService.generateExcel(titulo, columns, params).then(() => this.exportando = false);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/reportes/semanal-2/semanal-2.component.ts